module.exports = __webpack_public_path__ + "img/colored-paper-15.df318a1c.png";